import '/app/brewery-packages/content/content-editor-plugin-paragraph/src/Paragraph.css-raw';
export default {
  "paragraph": "jobs-2ec46bc8-paragraph-WaWZGW"
};